import ApiClient from '~/ApiClient';

import mapRegion from './mapRegion';
import Region from './Region';

export interface Result {
	items: Region[];
}

export default async function findRegions(client: ApiClient): Promise<Result> {
	const request = await client.fetch('analytics/regions');
	const response = await request.json();
	return { items: response.items.map(mapRegion) };
}
